export default __webpack_public_path__ + "media/images/ongletwhite-right2-6ae91c64667e2630dbe140cda2a0fb03.png";